import styled, { css } from 'styled-components';
import { withTheme } from '@dls/web';
import theme from '../../theme';

const ProductDetailsWrapper = withTheme(styled.div`
  ${({ coreTheme, ...p }) => css`
    margin-top: -${p.isCis ? theme.spacing(3) : 0};
    @media (min-width: ${coreTheme.brk_md}) {
      margin-top: -${p.isCis ? theme.spacing(6) : 0};
    }
  `}
`);

export { ProductDetailsWrapper };
